import { render, staticRenderFns } from "./MandateDetails.vue?vue&type=template&id=3fdb6ed4&"
import script from "./MandateDetails.vue?vue&type=script&lang=js&"
export * from "./MandateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fdb6ed4')) {
      api.createRecord('3fdb6ed4', component.options)
    } else {
      api.reload('3fdb6ed4', component.options)
    }
    module.hot.accept("./MandateDetails.vue?vue&type=template&id=3fdb6ed4&", function () {
      api.rerender('3fdb6ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandateDetails.vue"
export default component.exports